import { apiStoreLenses } from 'root/src/client/logic/api/lenses'

const { viewFollowProcessing } = apiStoreLenses

export default viewFollowProcessing
